/* ============================================================
   Watch Reserves — relay forms (Contact, Consign, Advisory).

   All three post the same shape to the Railway relay, which sends via the
   Resend HTTP API with Reply-To set to the sender. One handler covers them;
   each form declares its own name and endpoint on the element.
   ============================================================ */
(function () {
  'use strict';

  document.querySelectorAll('[data-wr-relay-form]').forEach(function (form) {
    var formName = form.dataset.form || 'Enquiry';
    var endpoint = form.dataset.endpoint;
    var button = form.querySelector('[data-wr-submit]');
    var errorBox = form.querySelector('[data-wr-form-error]');
    var success = document.querySelector('[data-wr-form-success]');
    var busy = false;

    function say(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = !message;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || !endpoint) return;

      // Collect every named control except the honeypot, which travels
      // separately so the relay can drop the submission silently.
      var fields = {};
      var company = '';
      form.querySelectorAll('input[name], textarea[name], select[name]').forEach(function (el) {
        if (el.name === 'company') { company = el.value; return; }
        if (el.value.trim()) fields[el.name] = el.value.trim();
      });

      if (!fields.Name || !fields.Email) {
        say('Please add your name and email.');
        return;
      }
      if (form.querySelector('textarea[required]') && !fields.Message) {
        say('Please add a message.');
        return;
      }

      // Each form had its own subject line in Framer — "Consign Inquiry — Name",
      // "Advisory Request — Name", "Contact: <subject> — Name". A single generic
      // format would have quietly reworded every notification landing in the
      // inbox, so the template travels on the element.
      var detail = fields.Subject || 'General Inquiry';
      var template = form.dataset.subject || '{form}: {detail} — {name}';
      var subject = template
        .replace('{form}', formName)
        .replace('{detail}', detail)
        .replace('{name}', fields.Name);

      busy = true;
      say('');
      if (button) {
        button.disabled = true;
        button.textContent = 'Sending...';
      }

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          form: formName,
          subject: subject,
          name: fields.Name || '',
          email: fields.Email || '',
          company: company,
          fields: fields
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to send');
          form.hidden = true;
          if (success) success.hidden = false;
        })
        .catch(function () {
          say('Something went wrong. Please email us directly at connect@watchreserves.com');
        })
        .finally(function () {
          busy = false;
          if (button) {
            button.disabled = false;
            button.textContent = 'Send Message';
          }
        });
    });

    form.addEventListener('input', function () { say(''); });
  });
})();
